import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeftDouble12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCaretLeftDouble12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.854 1.854a.5.5 0 0 0-.707-.708l-4.5 4.501-.354.354.353.353 4.5 4.501a.5.5 0 1 0 .708-.707L6.707 6.001zm-4.502.057a.5.5 0 0 0-.707-.707L1.203 5.646l-.353.353.353.354 4.444 4.443a.5.5 0 1 0 .707-.707L2.264 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeftDouble12);
